import { render, staticRenderFns } from "./DossierInvalRessource.vue?vue&type=template&id=5556a80a&scoped=true"
import script from "./DossierInvalRessource.vue?vue&type=script&lang=js"
export * from "./DossierInvalRessource.vue?vue&type=script&lang=js"
import style0 from "./DossierInvalRessource.vue?vue&type=style&index=0&id=5556a80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5556a80a",
  null
  
)

export default component.exports